export default __webpack_public_path__ + "static/media/Fredoka-Medium.df3a9eac.ttf";